export const SITE_URL = "https://agroproj.com";
export const SITE_NAME = "AgroProj";
export const SITE_DESCRIPTION =
  "Software para gestão de projetos agrícolas, produtores rurais, finanças e relatórios técnicos do agronegócio.";
